import React, { PropsWithChildren } from 'react';
import { Badge as BadgeNew } from './Badge';
import { convertOldBadgeProps } from './converter.old';
import type { OldBadgeProps } from './converter.old';

export type BadgeProps = OldBadgeProps;

export const Badge = (props: PropsWithChildren<BadgeProps>) => <BadgeNew {...convertOldBadgeProps(props)} />;
